// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Connection = createSvgIcon(
  { LeftToRight: <React.Fragment><circle cx="7.989" cy="13.0092" r=".5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-45 7.989 13.0092)" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.1103 10.8878c-1.1716-1.1716-3.0711-1.1716-4.2427 0M12.2316 8.7665c-2.3431-2.3431-6.1421-2.3431-8.4853 0M14.3529 6.6452c-3.5147-3.5147-9.2132-3.5147-12.7279 0" /></React.Fragment>, },
  'small'
);
